import React, { useCallback } from 'react'
// @ts-ignore no types
import { debounce } from 'lodash'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import classnames from 'classnames/bind'
import {
  Button,
  Grid,
  Icon,
  Text,
  useApplicationContext,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import type { Listing } from '@adc/sdk/types'
import { usePropertyContext } from '../../../context/property'
import { useListingContext } from '../../../context/listing'
import { withModalHooks } from '../../../hooks/useModalFeatures'
import { withNudgeHook } from '../../../hooks/useNudgesFeatures'
import { toggleOptinModal } from '../../../actions/modals'
import { getInitMarketingData } from '../../../utils/headers'
import AssetType from './assetType'
// @ts-ignore no types
import styles from './index.scss'

const cx = classnames.bind(styles)
const elmId = 'property_header'

interface PropertyHeaderProps {
  toggleSaveProperty: (saveData: any) => void
  featureFlags: any
  pushAuthQueueItem: () => void
  pushOnboardingQueueItem: () => void
  toggleAuthModal: () => void
  nudgeOptInModal?: () => void
}

const PropertyHeader = ({
  featureFlags,
  pushAuthQueueItem,
  pushOnboardingQueueItem,
  toggleAuthModal,
  nudgeOptInModal = () => {},
}: PropertyHeaderProps) => {
  const { user, embeddedContext } = useApplicationContext()
  const { listing } = useListingContext()
  const isMounted = hooks.useIsMounted()
  const isMobile = hooks.useIsMobileHook()
  const { property, propertyActions } = usePropertyContext()
  const isPropertySaved = property.is_currently_saved

  const debounceOnSave = useCallback(
    debounce(async (listing: Listing) => {
      await propertyActions?.toggleSaveProperty({
        listing,
        property,
        pushAuthQueueItem,
        toggleAuthModal,
        pushOnboardingQueueItem,
        nudgeOptInModal,
      })
    }, 500),
    [propertyActions, property]
  )

  const saveProperty = () => {
    debounceOnSave(listing)
  }

  const initMarketingData = getInitMarketingData({ listing, user })

  const { test, icon } = featureFlags['fe.resi.ab.testing.pdp.save.icon'] || {
    test: { version: '' },
    icon: { color: 'info' },
  }

  if (!isMounted) return null

  return (
    <div id='address' data-elm-id='address' className={cx('container')}>
      <script dangerouslySetInnerHTML={{ __html: initMarketingData }} />
      <div className={cx('u-pb-1', 'u-mb-1')}>
        <Grid verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column computer={8} tablet={8} mobile={8}>
              <AssetType listing={listing} showTutorial />
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={8}>
              <div
                className={cx(
                  'u-display-f',
                  'u-display-f-vcenter',
                  'u-text-center',
                  'u-display-f-end'
                )}
              >
                {!isMobile && (
                  <a
                    className={cx('header-link', 'sell-property')}
                    href={
                      featureFlags['fe.resi.enable-private-seller']
                        ? 'https://www.smartsale.com/sell/?utm_source=auction.com&utm_medium=referral&utm_campaign=pdpsl_new_00_000_000000_0000_0000&utm_term=&utm_content='
                        : 'https://www.auction.com/lp/sell-your-property/'
                    }
                    rel='noreferrer'
                    target='_blank'
                    data-elm-id='investment_info_sell_your_property_link'
                  >
                    <Icon
                      name='house-medical'
                      color='info'
                      size='medium'
                      iconStyle='regular'
                    />
                    <Text color='info' weight='heavy'>
                      Sell Your Property Faster
                    </Text>
                  </a>
                )}
                {embeddedContext !== 'webview' && (
                  <a
                    className={cx(
                      'header-link',
                      'hide-download-app-small-screen'
                    )}
                    href='https://auction.onelink.me/WqvL/fncodn9g'
                    rel='noreferrer'
                    data-elm-id='pdp_download_app'
                    target='_blank'
                  >
                    <Icon
                      name='mobile'
                      color='info'
                      size='medium'
                      iconStyle='regular'
                    />
                    <Text
                      color='info'
                      weight='heavy'
                      className={cx('no-wrap-text')}
                    >
                      Download App
                    </Text>
                  </a>
                )}
                <Button
                  className={cx(
                    'no-border-button',
                    'save-button',
                    // LaunchDarkly will determine the CSS color based on feature flags
                    // Possible values: 'redicon-outline', 'blueicon-box'
                    test?.version
                  )}
                  role='secondary'
                  tag='a'
                  onClick={saveProperty}
                  elmId={`${elmId}_save_button`}
                >
                  <Icon
                    name='heart'
                    iconStyle={isPropertySaved ? 'solid' : 'regular'}
                    color={icon?.color || 'info'}
                  />{' '}
                  {isPropertySaved ? 'Saved' : 'Save'}
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </div>
  )
}

const mapStateToProps = (store: any) => ({
  buyerViews: store.propertyAnalytics.propertyViews,
  user: store.user,
  featureFlags: store.featureFlags,
})

const mapDispatchToProps = (dispatch: any) => ({
  openOptInModal: () => dispatch(toggleOptinModal(true)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNudgeHook(withModalHooks(PropertyHeader)))
